<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-reports">
                <b-row>
                    <b-col cols="12" lg="8">
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <print-button content="all-reports" :refs="$refs">
                                    {{ $i18n.gt('PRINT_ALL_LABEL') }}
                                </print-button>
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="sun"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_REPORTS') }}
                                </h5>
                            </b-card-header>
                            <b-card-body>
                                <div ref="all-reports">
                                    <b-row>
                                        <template v-if="$utils.themeIs('wellcoaches')">
                                            <b-col cols="12" lg="12">
                                                <h4>WBI Score Report</h4>
                                                <b-row class="trend-row">
                                                    <participant-score-chart class="col-6" scores="WBI_MIND"
                                                                             :show-y-axis="true"
                                                                             :y-values="[0,3,7,10]"/>
                                                    <participant-score-chart class="col-6" scores="WBI_BODY"
                                                                             :show-y-axis="true"
                                                                             :y-values="[0,3,7,10]"/>
                                                </b-row>
                                                <b-row class="trend-row">
                                                    <participant-score-chart class="col-6" scores="WBI_LIFE"
                                                                             :show-y-axis="true"
                                                                             :y-values="[0,3,7,10]"/>
                                                    <participant-score-chart class="col-6" scores="WBI_WORK"
                                                                             :show-y-axis="true"
                                                                             :y-values="[0,3,7,10]"/>
                                                </b-row>
                                                <b-row class="trend-row">
                                                    <participant-score-chart class="col-6" scores="WBI_OVERALL"
                                                                             :show-y-axis="true"
                                                                             :y-values="[0,3,7,10]"/>
                                                </b-row>
                                            </b-col>

                                            <b-col cols="12" lg="12">
                                                <h4>Positivity Report</h4>
                                                <b-row class="trend-row">
                                                    <participant-score-chart class="col-6" scores="RATIO_SCORE"/>
                                                </b-row>
                                            </b-col>
                                        </template>

                                        <b-col cols="12" lg="12">
                                            <h4>Lifestyle Report</h4>
                                            <b-row class="trend-row">
                                                <participant-score-chart class="col-6" scores="SCORE_EXER"/>
                                                <participant-score-chart class="col-6" scores="SCORE_DIET"/>
                                            </b-row>
                                            <b-row class="trend-row">
                                                <participant-score-chart class="col-6" scores="SCORE_STRESS"/>
                                                <participant-score-chart class="col-6" scores="SCORE_SLEEP"/>
                                            </b-row>
                                            <b-row class="trend-row">
                                                <participant-score-chart class="col-6" scores="TOTAL_SCORE"/>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="12" lg="12">
                                            <h4>Legend</h4>
                                            <b-row class="trend-legend">
                                                <b-col style="display: flex; justify-content: space-around">
                                                    {{ $i18n.gt('LABEL_GAUGE_LOW_RISK') }}
                                                    <div
                                                        style="height:2em; width: 2em; background-color: #00E81D4D"></div>
                                                </b-col>
                                                <b-col style="display: flex; justify-content: space-around">
                                                    {{ $i18n.gt('LABEL_GAUGE_INCREASED_RISK') }}
                                                    <div
                                                        style="height:2em; width: 2em; background-color: #FFF8154D"></div>
                                                </b-col>
                                                <b-col style="display: flex; justify-content: space-around">
                                                    {{ $i18n.gt('LABEL_GAUGE_HIGH_RISK') }}
                                                    <div
                                                        style="height:2em; width: 2em; background-color: #FFAA154D"></div>
                                                </b-col>
                                                <b-col style="display: flex; justify-content: space-around">
                                                    {{ $i18n.gt('LABEL_GAUGE_VERY_HIGH_RISK') }}
                                                    <div
                                                        style="height:2em; width: 2em; background-color: #EB001B4D"></div>
                                                </b-col>
                                            </b-row>
                                        </b-col>

                                    </b-row>
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'
import * as _ from 'lodash'

/**
 * Page to display various reports for a Participant, with print function
 */
export default Vue.extend({
    name: 'MyReports',
    mixins: [PatientPageMixin],
    computed: {
        goals () {
            return this.participant.wellness_plan.goals
        },
        habits () { // NB: don't show archived habits
            return _.filter(this.participant.wellness_plan.habits, (habit) => {
                return !habit.archivedTimestamp
            })
        }
    },
    async mounted () {
        try {
            await this.$store.dispatch('getParticipantScores', { participantId: this.$store.state.currentUser.participantId })
        } catch (e) {
            this.$utils.handleError(e, 'Could not load scores')
        }
    },
})
</script>

<style lang="scss">
@media print {
    #print-container {
        div.row div.row {
            display: inline-block;

        }
    }
}

@media (max-width: 719px) {
    .row {
      & .trend-row {
        flex-direction: column;

        .col-6 {
          max-width: 100%;
        }
      }
    }
    .trend-legend {
        div {
            flex: 0 0 50%;

            div {
                margin-left: 5px;
            }
        }
    }
}
</style>

